import { ArrowRight, ClipboardList, Receipt, RefreshCw, Ticket } from "lucide-react";

import { Footer } from "@/components/Frame";
import { detectCredential, KIND_META } from "@/lib/credential";

/**
 * ADR-CMRC-013 (Fase 3): la pantalla muestra el tipo detectado del credential
 * (código/CFDI comparten shape UUID — el backend desambigua al canjear;
 * cotización se detecta por folio). El icono y los labels siguen al tipo.
 */
export function Redeem({
  code,
  redeeming,
  onRedeem,
  onChangeCode,
}: {
  code: string;
  redeeming: boolean;
  onRedeem: () => void;
  onChangeCode: () => void;
}) {
  const kind = detectCredential(code);
  const meta = kind !== "unknown" ? KIND_META[kind] : KIND_META.uuid;

  // UUIDs se enmascaran (son secretos canjeables); folios de cotización no
  // (no son secretos y el usuario quiere verificar el suyo).
  const display =
    kind === "uuid" && code.length > 8
      ? "····-····-····-" + code.slice(-4).toUpperCase()
      : code.toUpperCase();

  const Icon =
    meta.icon === "clipboard" ? ClipboardList : meta.icon === "receipt" ? Receipt : Ticket;

  const lede =
    kind === "quote" || kind === "folio"
      ? "Tienes una cotización aprobada. Vamos a activarla."
      : "Tienes un código o factura válida. Vamos a activarla.";

  return (
    <>
      <div className="screen">
        <h1 className="h1">Activa tu cuenta</h1>
        <p className="lede">{lede}</p>

        <div className="code-card">
          <div className="code-card__ic">
            <Icon size={22} strokeWidth={1.5} />
          </div>
          <div className="code-card__body">
            <div className="code-card__label">{meta.label}</div>
            <div className="code-card__value tnum">{display}</div>
            <div className="code-card__ok">✓ {meta.sub}</div>
          </div>
        </div>

        <div className="eyebrow" style={{ marginTop: 28 }}>
          Vas a activar
        </div>
        <div className="pkg-card">
          <div className="pkg-card__title">
            {kind === "quote" || kind === "folio"
              ? "Los productos de tu cotización"
              : "Tu paquete Synapta"}
          </div>
          <div className="pkg-card__sub">
            {kind === "quote" || kind === "folio"
              ? "Según el detalle aprobado con tu asesor"
              : "Se detecta automáticamente al activar"}
          </div>
        </div>

        <button
          className="footer__link"
          style={{ marginTop: 16, alignSelf: "flex-start" }}
          onClick={onChangeCode}
          disabled={redeeming}
        >
          Probar otro código o folio →
        </button>
      </div>
      <Footer>
        <button
          className="btn btn--primary btn--block"
          disabled={redeeming}
          onClick={onRedeem}
        >
          {redeeming ? (
            <>
              <RefreshCw size={18} className="spin" /> Activando…
            </>
          ) : (
            <>
              Activar mi cuenta <ArrowRight size={20} />
            </>
          )}
        </button>
      </Footer>
    </>
  );
}
